import { AutogenModelEdiDeclineCodes, AutogenRowEdiDeclineCodes } from "./autogen/AutogenModelEdiDeclineCodes";

export class ModelEdiDeclineCodes extends AutogenModelEdiDeclineCodes<RowEdiDeclineCodes> {
    constructor() {
        super(RowEdiDeclineCodes);
    }
}

export class RowEdiDeclineCodes extends AutogenRowEdiDeclineCodes {
}